var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{attrs:{"pageProps":{
    title: 'Change email',
    description:
      _vm.step === 1
        ? 'Please enter your current credentials to proceed'
        : 'Please choose your new email and password',
  }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"20px"}},[(_vm.step === 1)?_c('LoginForm',{attrs:{"button_text":"Next"},on:{"success":_vm.next}}):_vm._e(),(_vm.step === 2)?_c('ChangeEmail'):_vm._e()],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }